var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _rect2, _rect3, _rect4, _rect5, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect6, _path30, _circle, _circle2, _circle3, _path31, _rect7, _rect8, _rect9, _rect10, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 405,
    viewBox: "0 0 346 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.771 229.204L224.006 246.248H230.336V250.631H234.719V246.248H241.537L232.771 229.204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.457 257.935C189.104 265.053 199.639 274.751 208.494 273.031C212.967 272.163 217.012 268.381 219.136 259.883H250.789V211.186C249.978 205.505 245.432 194.142 233.745 194.142H174.335C179.042 194.954 188.457 199.499 188.457 211.186V220.439V257.935ZM224.006 246.248L232.771 229.204L241.537 246.248H234.719V250.631H230.336V246.248H224.006Z",
    fill: "#31485F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.859 273.031C274.261 271.083 276.436 263.454 276.599 259.883H250.789H219.136C217.012 268.381 212.967 272.163 208.494 273.031H232.284H241.537H266.859Z",
    fill: "#263849"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.395 211.186H177.257H188.457C188.457 199.499 179.042 194.954 174.335 194.142C168.491 193.331 156.122 195.603 153.395 211.186Z",
    fill: "#1E2C39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.578 277.901V285.693V297.38L152.421 294.458L154.856 299.815L159.726 297.38L156.804 292.023L162.648 289.101L157.757 285.693L146.578 277.901Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.052 334.389C199.412 327.34 204.655 320.739 215.727 317.346H241.537V312.476H228.632H215.727C204.014 314.023 196.012 323.695 193.906 334.389H198.052Z",
    fill: "#232932"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.25 317.346C267.346 315.885 277.572 287.64 252.25 282.284H241.537V285.693H252.25C264.424 287.64 269.294 307.606 252.25 312.476H241.537V317.346H252.25Z",
    fill: "#232932"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.107 361.173L215.727 360.686C204.934 360.069 195.702 346.562 198.052 334.389H193.906C191.372 347.259 197.376 361.611 215.727 365.069H232.341C232.479 363.82 232.724 362.503 233.107 361.173Z",
    fill: "#232932"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.537 334.389V317.346H215.727C204.655 320.739 199.412 327.34 198.052 334.389H241.537Z",
    fill: "#3B4851"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.599 369.451C276.599 351.92 264.911 347.538 259.068 347.538H258.581H250.789C250.625 347.549 250.463 347.562 250.302 347.576C239.636 348.519 234.887 354.98 233.107 361.173C232.724 362.503 232.479 363.82 232.341 365.069C232.162 366.689 232.164 368.191 232.284 369.451H241.537L247.867 356.303L254.685 369.451L259.068 361.173L263.45 369.451H276.599Z",
    fill: "#232932"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.068 347.538C264.911 347.538 276.599 351.92 276.599 369.451H293.642C294.454 362.958 292.474 349.485 278.059 347.538H259.068Z",
    fill: "#31485F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.789 347.538H258.581H259.068C259.068 346.077 258.191 343.155 254.685 343.155C251.179 343.155 250.302 346.103 250.302 347.576C250.463 347.562 250.625 347.549 250.789 347.538Z",
    fill: "#31485F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.882 351.92H145.117L154.856 369.451H165.083L171.413 356.303L178.231 369.451H184.561V351.92H153.882Z",
    fill: "#31485F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.351 361.173L140.734 369.451H154.856L145.117 351.92H114.438V369.451H123.69L127.586 361.173L131.969 369.451L136.351 361.173Z",
    fill: "#232932"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.117 334.389V351.92H153.882V334.389H145.117Z",
    fill: "#232932"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4623 211.186V334.389H66.2278V211.186H57.4623Z",
    fill: "#232932"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.578 285.693V277.901L157.757 285.693H159.465C164.988 285.693 169.465 281.215 169.465 275.693V267.935C169.465 262.412 164.988 257.935 159.465 257.935H100.089C94.5664 257.935 90.0893 262.412 90.0893 267.935V275.693C90.0893 281.215 94.5664 285.693 100.089 285.693H146.578Z",
    fill: "#D72424"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2278 211.186V334.389H145.117H153.882H193.906C196.012 323.695 204.014 314.023 215.727 312.476H228.632H241.537V285.693V282.284H232.284V307.606H74.5062V220.439H177.257V211.186H153.395H66.2278Z",
    fill: "#3B4851"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.257 220.439H74.5062V307.606H232.284V282.284H208.494C184.398 282.284 177.629 266.051 177.257 257.935V220.439ZM146.578 297.38V285.693H100.089C94.5664 285.693 90.0893 281.215 90.0893 275.693V267.935C90.0893 262.412 94.5664 257.935 100.089 257.935H159.465C164.988 257.935 169.465 262.412 169.465 267.935V275.693C169.465 281.215 164.988 285.693 159.465 285.693H157.757L162.648 289.101L156.804 292.023L159.726 297.38L154.856 299.815L152.421 294.458L146.578 297.38Z",
    fill: "#313942"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.457 220.439V211.186H177.257V220.439H188.457Z",
    fill: "#35424A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.494 273.031C199.639 274.751 189.104 265.053 188.457 257.935V220.439H177.257V257.935C177.629 266.051 184.398 282.284 208.494 282.284H232.284V273.031H208.494Z",
    fill: "#2C343D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M241.537 273.031H232.284V282.284H241.537V273.031Z",
    fill: "#35424A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.7847,
    y: 229.691,
    width: 58.4363,
    height: 3.89575,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7588,
    y: 242.352,
    width: 35.0618,
    height: 4.86969,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7588,
    y: 294.945,
    width: 39.9315,
    height: 4.86969,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175.309,
    y: 294.945,
    width: 18.5048,
    height: 4.86969,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 201.605,
    y: 294.945,
    width: 22.4006,
    height: 4.86969,
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6351 325.137H48.6969V369.938H13.6351V360.686V356.303V338.772V334.876V325.137Z",
    fill: "#D72424"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6351 334.876C9.09009 334.552 0 336.727 0 348.025C0 359.322 9.09009 361.173 13.6351 360.686V356.303C10.7133 356.465 4.86969 355.037 4.86969 348.025C4.86969 341.012 10.7133 338.934 13.6351 338.772V334.876Z",
    fill: "#D72424"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7408 352.407L74.597 369.938H56.8845L65.7408 352.407Z",
    fill: "#5A6B76"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2718 352.407L92.128 369.938H74.4155L83.2718 352.407Z",
    fill: "#5A6B76"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.903 316.372L292.759 333.902H275.047L283.903 316.372Z",
    fill: "#5A6B76"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M283.903 298.841L292.759 316.372H275.047L283.903 298.841Z",
    fill: "#5A6B76"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86963 378.704H302.895V387.469H4.86963V378.704Z",
    fill: "#3B4851"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6611,
    y: 387.469,
    width: 281.468,
    height: 17.5309,
    fill: "#232932"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6648 340.305H27.4575L31.4631 350.078H31.6336L35.6393 340.305H39.4319V354.85H36.4489V345.383H36.3282L32.564 354.779H30.5327L26.7685 345.348H26.6478V354.85H23.6648V340.305Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.35,
    cy: 323.676,
    r: 4.38272,
    fill: "#F05555"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.0111,
    cy: 323.676,
    r: 4.38272,
    fill: "#5A6B76"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.526,
    cy: 323.676,
    r: 4.38272,
    fill: "#F05555"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8217 277V267.545H103.552C104.266 267.545 104.875 267.673 105.38 267.929C105.888 268.181 106.274 268.54 106.539 269.004C106.806 269.466 106.94 270.009 106.94 270.634C106.94 271.262 106.805 271.802 106.534 272.254C106.263 272.704 105.871 273.048 105.357 273.288C104.846 273.528 104.227 273.648 103.501 273.648H101.004V272.042H103.178C103.56 272.042 103.877 271.99 104.129 271.885C104.381 271.78 104.569 271.623 104.692 271.414C104.818 271.205 104.881 270.945 104.881 270.634C104.881 270.32 104.818 270.055 104.692 269.84C104.569 269.624 104.38 269.461 104.124 269.35C103.872 269.237 103.553 269.18 103.169 269.18H101.821V277H99.8217ZM104.928 272.697L107.277 277H105.071L102.772 272.697H104.928ZM108.353 277V267.545H114.724V269.194H110.352V271.446H114.396V273.094H110.352V275.352H114.742V277H108.353ZM122.582 270.602C122.517 270.377 122.427 270.178 122.31 270.006C122.193 269.831 122.05 269.683 121.88 269.563C121.714 269.44 121.523 269.346 121.308 269.281C121.096 269.217 120.86 269.184 120.602 269.184C120.118 269.184 119.694 269.304 119.328 269.544C118.964 269.784 118.681 270.134 118.478 270.592C118.275 271.048 118.173 271.605 118.173 272.263C118.173 272.922 118.273 273.482 118.473 273.944C118.674 274.406 118.957 274.758 119.323 275.001C119.689 275.241 120.122 275.361 120.62 275.361C121.073 275.361 121.459 275.281 121.779 275.121C122.102 274.958 122.348 274.729 122.517 274.433C122.69 274.138 122.776 273.788 122.776 273.385L123.182 273.445H120.745V271.94H124.701V273.131C124.701 273.962 124.526 274.676 124.175 275.273C123.824 275.867 123.341 276.326 122.725 276.649C122.11 276.969 121.405 277.129 120.611 277.129C119.725 277.129 118.946 276.934 118.275 276.543C117.604 276.149 117.081 275.59 116.705 274.867C116.333 274.141 116.147 273.279 116.147 272.282C116.147 271.516 116.258 270.832 116.479 270.232C116.704 269.629 117.018 269.118 117.421 268.7C117.824 268.281 118.293 267.962 118.829 267.744C119.364 267.525 119.945 267.416 120.569 267.416C121.105 267.416 121.603 267.495 122.065 267.652C122.527 267.806 122.936 268.024 123.293 268.307C123.653 268.59 123.947 268.927 124.175 269.318C124.403 269.706 124.549 270.134 124.613 270.602H122.582ZM128.202 267.545V277H126.203V267.545H128.202ZM134.975 270.265C134.938 269.892 134.78 269.603 134.5 269.397C134.219 269.19 133.839 269.087 133.359 269.087C133.033 269.087 132.758 269.134 132.533 269.226C132.308 269.315 132.136 269.44 132.016 269.6C131.899 269.76 131.84 269.941 131.84 270.145C131.834 270.314 131.87 270.462 131.947 270.588C132.027 270.714 132.136 270.823 132.274 270.915C132.413 271.005 132.573 271.083 132.755 271.151C132.936 271.216 133.13 271.271 133.336 271.317L134.186 271.52C134.598 271.613 134.977 271.736 135.321 271.89C135.666 272.043 135.965 272.233 136.217 272.457C136.469 272.682 136.665 272.947 136.803 273.251C136.945 273.556 137.017 273.905 137.02 274.299C137.017 274.878 136.869 275.38 136.577 275.804C136.288 276.226 135.869 276.554 135.321 276.788C134.777 277.018 134.119 277.134 133.35 277.134C132.587 277.134 131.922 277.017 131.356 276.783C130.793 276.549 130.352 276.203 130.035 275.744C129.722 275.283 129.557 274.712 129.541 274.032H131.476C131.497 274.349 131.588 274.613 131.748 274.826C131.911 275.035 132.128 275.193 132.399 275.301C132.673 275.406 132.982 275.458 133.327 275.458C133.666 275.458 133.959 275.409 134.209 275.31C134.461 275.212 134.657 275.075 134.795 274.9C134.934 274.724 135.003 274.522 135.003 274.295C135.003 274.082 134.94 273.904 134.813 273.759C134.69 273.615 134.509 273.491 134.269 273.39C134.032 273.288 133.741 273.196 133.396 273.113L132.367 272.854C131.57 272.661 130.94 272.357 130.479 271.945C130.017 271.533 129.788 270.977 129.791 270.278C129.788 269.706 129.94 269.206 130.248 268.778C130.559 268.35 130.985 268.016 131.527 267.776C132.068 267.536 132.684 267.416 133.373 267.416C134.075 267.416 134.687 267.536 135.21 267.776C135.737 268.016 136.146 268.35 136.438 268.778C136.731 269.206 136.882 269.701 136.891 270.265H134.975ZM138.005 269.194V267.545H145.77V269.194H142.875V277H140.899V269.194H138.005ZM147.048 277V267.545H153.419V269.194H149.047V271.446H153.091V273.094H149.047V275.352H153.438V277H147.048ZM155.008 277V267.545H158.738C159.452 267.545 160.062 267.673 160.566 267.929C161.074 268.181 161.461 268.54 161.725 269.004C161.993 269.466 162.127 270.009 162.127 270.634C162.127 271.262 161.991 271.802 161.721 272.254C161.45 272.704 161.057 273.048 160.543 273.288C160.033 273.528 159.414 273.648 158.688 273.648H156.19V272.042H158.364C158.746 272.042 159.063 271.99 159.315 271.885C159.568 271.78 159.756 271.623 159.879 271.414C160.005 271.205 160.068 270.945 160.068 270.634C160.068 270.32 160.005 270.055 159.879 269.84C159.756 269.624 159.566 269.461 159.311 269.35C159.058 269.237 158.74 269.18 158.355 269.18H157.007V277H155.008ZM160.114 272.697L162.464 277H160.257L157.958 272.697H160.114Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 205.501,
    y: 233.587,
    width: 19.4788,
    height: 4.86969,
    fill: "#F05555"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 205.501,
    y: 226.769,
    width: 19.4788,
    height: 4.86969,
    fill: "#F05555"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 205.501,
    y: 219.952,
    width: 19.4788,
    height: 4.86969,
    fill: "#F05555"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 205.501,
    y: 206.317,
    width: 31.166,
    height: 4.86969,
    fill: "#F05555"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.118,
    cy: 236.022,
    r: 2.43485,
    fill: "#F05555"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.118,
    cy: 229.204,
    r: 2.43485,
    fill: "#F05555"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.118,
    cy: 222.387,
    r: 2.43485,
    fill: "#F05555"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.118,
    cy: 208.751,
    r: 2.43485,
    fill: "#F05555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.be72d4620b2629c18255dd18de8a13cd.svg";
export { ForwardRef as ReactComponent };